import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	ForgotPasswordValidateToken,
	ForgotPasswordValidateTokenParams,
	ForgotPasswordValidateTokenModel,
} from 'domain/usecases';

export class RemoteForgotPasswordValidateToken implements ForgotPasswordValidateToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ForgotPasswordValidateTokenModel>,
	) {}

	async validateToken({
		signal,
		...params
	}: ForgotPasswordValidateTokenParams): Promise<ForgotPasswordValidateTokenModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(
					httpResponse.status,
					httpResponse.data,
					undefined,
					httpResponse.headers,
				);
		}
	}
}
